const placeholder = require("../assets/images/placeholder.png");
const iconWhite = require("../assets/images/iconWhite.png");

export { placeholder, iconWhite };
